type PrefixedKeys<Prefix extends string, Values> = {
  [Key in keyof Values as `${Prefix}[${Key & string}]`]: Values[Key];
};

// Flattens one level of a nested request body into bracketed query keys, e.g.
// prefixKeys('filter', { driver_ids }) returns { 'filter[driver_ids]': driver_ids }.
export default function prefixKeys<Prefix extends string, Values extends object>(
  prefix: Prefix,
  values: Values,
) {
  // Object.fromEntries widens the keys to string; PrefixedKeys restores them.
  return Object.fromEntries(
    Object.entries(values).map(([key, value]) => [`${prefix}[${key}]`, value]),
  ) as PrefixedKeys<Prefix, Values>;
}
